import { Fade, Paper } from "@material-ui/core";
import React, { useState } from "react";
import { BsChevronUp } from "react-icons/bs";
import ServicesList from "../../components/ServicesList";
//Movie Slider
import MovieSlider from "../MovieSlider";
import "./ImageBanner.scss";

const ImageBanner = (props) => {
  const [isServicesviewVisible, setisServicesviewVisible] = useState(false);

  const showArrow =
    props.imageBannerData?.downArrow !== undefined
      ? props.imageBannerData.downArrow
      : true;

  const toggleServicesList = () => {
    setisServicesviewVisible(!isServicesviewVisible);
    // let stickyClass = document.getElementsByClassName('sticky').length;
    // if (stickyClass > 0) {
    //   document.getElementById("ImgSubTitle") && document.getElementById("ImgSubTitle").classList.remove("sub-title-height-clicked");
    //   document.getElementById("ImgSubTitle") && document.getElementById("ImgSubTitle").classList.toggle("sub-title-height-clicked");
    // }
  };

  return (
    <div className={`${props.imageBannerData.parentClass}`} id="">
      {!props.imageBannerData.imageUrl ? (
        <img
          className={
            props.imageBannerData.specificStyle === "yes"
              ? "imageBannerfullClient"
              : "imageBannerfull"
          }
          src={props.imageBannerData.bnrImg}
          alt={props.imageBannerData.bannerImageAlt}
          width="100%"
        />
      ) : (
        <MovieSlider
          movieSlider={{ imageUrl: props.imageBannerData.imageUrl }}
        />
      )}
      <div className="overlay">
        <div className="body-container">
          <h1
            className={
              props.imageBannerData.autoWidth
                ? `bnr-img-title1 ${props.imageBannerData.subtitleclassname}`
                : `bnr-img-title ${props.imageBannerData.subtitleclassname}`
            }
          >
            {props.imageBannerData.bnrImgTitle}
          </h1>
        </div>
        {props.imageBannerData.component && (
          <div
            id={props.imageBannerData.component === "Who" ? "" : "ImgSubTitle"}
            className={"imgSubTitle sub-title-height"}
          >
            <div className="body-container">
              {props.imageBannerData.bnrImgSubTitle && (
                <div
                  className={`bnr-img-subtitle ${props.imageBannerData.subtitleclassname}`}
                  onClick={() => {
                    showArrow && toggleServicesList();
                  }}
                  role="presentation"
                >
                  {props.imageBannerData.bnrImgSubTitle}
                  {/* {isServicesviewVisible ? ( */}
                  {showArrow && (
                    <BsChevronUp
                      className={
                        isServicesviewVisible
                          ? "BnrImgIcon"
                          : "BnrImgIconRotate"
                      }
                    />
                  )}
                  {/* ) : ( */}
                  {/* <BsChevronDown className="BnrImgIcon" /> */}
                  {/* )} */}
                </div>
              )}
            </div>
            <div className="body-container">
              {isServicesviewVisible ? (
                <Fade
                  timeout={{ enter: 800, exit: 800 }}
                  in={true}
                  mountOnEnter
                  unmountOnExit
                >
                  <Paper elevation={3}>
                    <ServicesList
                      customClass="serviceslist-bglayout"
                      insightsbannerimg={
                        props.imageBannerData.insightsbannerimg
                      }
                      servicesColumn1={props.imageBannerData.servicesColumn1}
                      servicesColumn2={props.imageBannerData.servicesColumn2}
                      servicesColumn3={props.imageBannerData.servicesColumn3}
                    />
                  </Paper>
                </Fade>
              ) : (
                <Fade
                  timeout={{ enter: 800, exit: 800 }}
                  out={true}
                  mountOnEnter
                  unmountOnExit
                >
                  <Paper elevation={3}>
                    <ServicesList
                      customClass="serviceslist-bglayout"
                      insightsbannerimg={
                        props.imageBannerData.insightsbannerimg
                      }
                      servicesColumn1={props.imageBannerData.servicesColumn1}
                      servicesColumn2={props.imageBannerData.servicesColumn2}
                      servicesColumn3={props.imageBannerData.servicesColumn3}
                    />
                  </Paper>
                </Fade>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ImageBanner;
